import { fetchWrapper } from "../utils/fetchWrapper";
import globalState from "./global-state";

import { gotoLead } from "./pages/lead";

export interface ISimulacaoState {
    idSimulacao: number
    corretoraNome: string
    header: {
        idSimulacao: number
        corretoraImageBase64: string
        nome: string
        cpfCnpj: string
        tipoPessoa: number
        dtHrCalculo: string
    }
}

const getSimulacaoFetch = () =>
    fetchWrapper<ISimulacaoState>("/api/Simulacao");

export const init = async () => {
    const simulacao = await getSimulacaoFetch()

    globalState.simulacaoState.set(simulacao)

    await gotoLead()
}

